export default __webpack_public_path__ + "static/media/green-timberline.6e269779.png";